import React, { useContext, useRef } from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function NavMenu({ isMobileMenuOpen, setIsMobileMenuOpen }) {
  const { isAuthenticated, userType, userDetails, userLogout } = useContext(
    AuthContext
  );
  const location = useLocation();

  const logout = async () => {
    await userLogout();
  };

  const isActive = (path) => {
    return location.pathname + location.search === path ? "active" : "";
  };

  // const heartbeatRef = useRef(null);
  // const handleMouseEnter = () => {
  //   if (heartbeatRef.current) {
  //     heartbeatRef.current.currentTime = 0;
  //     heartbeatRef.current.play();
  //   }
  // };
  // const handleMouseLeave = () => {
  //   if (heartbeatRef.current) {
  //     heartbeatRef.current.pause();
  //     heartbeatRef.current.currentTime = 0;
  //   }
  // };

  const navMenus = () => {
    if (!isAuthenticated) {
      return (
        <React.Fragment>

          <div className={`nav-animation header-nav navbar-collapse collapse d-flex ${ isAuthenticated ? "justify-content-end" : "" }`} >
            <ul className="nav navbar-nav">
              <li>
                <Link className={isActive("/job_search")} to={`/job_search`}>Search Jobs</Link>
              </li>
              {/* <li>
                <Link to={`/pages/career-service`}>Career Service</Link>
              </li> */}
              <li>
                <Link className={isActive("/blog")} to={`/blog`}>Blog</Link>
              </li>
              <li>
                <Link className={isActive("/training")} to={`/training`}>Training</Link>
              </li>
              <li>
                <Link className={isActive("/faq")} to={`/faq`}>Faq</Link>
              </li>
              <li>
                <Link className={isActive("/contact-us")} to={`/contact-us`}>Contact</Link>
              </li>
            </ul>
          </div>
        </React.Fragment>
      );
    }

    if (userType == "seeker") {
      return (
        <React.Fragment>
          <div className={`nav-animation header-nav navbar-collapse collapse d-flex ${ isAuthenticated ? "justify-content-center" : "" }`} >
            <ul className="nav navbar-nav">
              <li>
                <Link className={isActive("/job_search")} to={`/job_search`}>Search Jobs</Link>
              </li>
              {/* <li>
                <Link to={`/pages/career-service`}>Career Service</Link>
              </li> */}
              <li>
                <Link className={isActive("/blog")} to={`/blog`}>Blog</Link>
              </li>
              <li>
                <Link className={isActive("/training")} to={`/training`}>Training</Link>
              </li>
              <li>
                <Link className={isActive("/faq")} to={`/faq`}>Faq</Link>
              </li>
              <li>
                <Link className={isActive("/contact-us")} to={`/contact-us`}>Contact</Link>
              </li>
            </ul>
          </div>
          {/* <li>
            <Link className={isActive("/job_search")} to={`/job_search`}>Search Jobs</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=dashboard")} to="/profile?tab=dashboard">
              Dashboard
            </Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=myProfile")} to="/profile?tab=myProfile">My Profile</Link>
          </li>
          <li>
            <Link to="/profile?tab=editProfile">Edit Profile</Link>
          </li>
          <li>
            <Link className={isActive("/profile?tab=appliedJobs")} to="/profile?tab=appliedJobs">Applied Jobs</Link>
          </li> */}
        </React.Fragment>
      );
    } else if (userType == "employer") {
      return (
        <React.Fragment>
          <div className={`nav-animation header-nav navbar-collapse collapse d-flex ${ isAuthenticated ? "justify-content-end" : "" }`} >
            {/* <ul className="nav navbar-nav">
              <li>
                <Link className={isActive("/profile?tab=dashboard")} to="/profile?tab=dashboard">Dashboard</Link>
              </li>
              <li>
                <Link className={isActive("/profile?tab=myProfile")} to="/profile?tab=myProfile">Company Profile</Link>
              </li>
              <li>
                <Link className={isActive("/profile?tab=editProfile")} to="/profile?tab=editProfile">Edit Profile</Link>
              </li>
              <li>
                <Link className={isActive("/profile?tab=postJob")} to="/profile?tab=postJob">Post A Job</Link>
              </li>
            </ul> */}
          </div>
        </React.Fragment>
      );
    }
  };

  const rightMenu = () => {
    if (!isAuthenticated) {
      return (
        <div className="extra-nav header-2-nav">
          <div className="extra-cell">
            <div className="header-nav-btn-section">
              <div className="twm-nav-btn-left">
                <Link to={"/login-seeker"} className="twm-nav-post-a-job">
                  <i className="ri-briefcase-line"></i> Login
                </Link>
              </div>
              <div className="twm-nav-btn-right">
                <Link to={"/register-seeker"} className="twm-nav-sign-up">
                  <i className="ri-login-box-line"></i> Sign Up
                </Link>
              </div>
              <div className="custom-vertical-line"></div>
              <div className="nav-employer-zone">
                <Link to={"/employer-zone"}>
                   Employer Zone
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (userType == "seeker") {
      return (
        
        <div className="d-flex">
          <div className="main_dash_link">
            <Link className={``} to="/profile?tab=dashboard">
               Dashboard
            </Link>
          </div>
          <div className="dropdown header_notification">
              {/* <audio ref={heartbeatRef} src="/portal/images/bell.mp3" preload="auto" />
              <Link
                className="dropdown-toggle link-notification"
                to="/"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <i className="fa fa-bell-o"></i>
              </Link> */}

            <Link className={`dropdown-toggle link-notification`} to="/" 
              data-bs-toggle="dropdown" aria-expanded="false" id="play">
              <i className="fa fa-bell-o"></i>
            </Link>
            <div className="dropdown-menu text-small">
                <div className="dashboard-notifications-list flex-grow-1">
                  <div className="notifications_filter">
                    <Link to="/notifications">Unread</Link>
                    <Link to="/notifications" className={`active`}>All</Link>
                    <input type="text" placeholder="Search notifications" />
                  </div>
                    <div className="dashboard-notification-item position-relative">
                        <div className="dashboard-notification-dot"></div>
                        <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                        <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                            been shortlisted.</p>
                        <span className="dashboard-notification-time">Invalid Date</span>
                    </div>
                    <div className="dashboard-notification-item position-relative read">
                        <div className="dashboard-notification-dot"></div>
                        <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                        <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                            been shortlisted.</p>
                        <span className="dashboard-notification-time">Invalid Date</span>
                    </div>
                    <div className="dashboard-notification-item position-relative read">
                        <div className="dashboard-notification-dot"></div>
                        <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                        <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                            been shortlisted.</p>
                        <span className="dashboard-notification-time">Invalid Date</span>
                    </div>
                    <div className="dashboard-notification-item position-relative read">
                        <div className="dashboard-notification-dot"></div>
                        <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                        <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                            been shortlisted.</p>
                        <span className="dashboard-notification-time">Invalid Date</span>
                    </div>
                </div>
                <div className="notification_footer">
                    {/* <a href="javascript:;" className="dashboard-notifications-view-all-btn btn w-100">View All</a> */}
                    <Link to="/notifications" className={`text-dark`}><b>Mark all read</b></Link>
                    <Link to="/notifications" className={`text-danger`}>Clear all</Link>
                </div>
            </div>
          </div>
          <div className="dropdown text-end">
            <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle"
              data-bs-toggle="dropdown" aria-expanded="false" >
              <img  
              src={userDetails.photo ? `/uploads/candidate_photo/${userDetails.photo}` : '/default/profile_picture.png'}
              alt=""  
              className="rounded-circle" />
              {/* <strong>{userDetails.first_name || userDetails.username}</strong> */}
            </a>
            <ul className="dropdown-menu text-small shadow header_account_dropdown">
              <li>
                <strong>{userDetails.first_name || userDetails.username}</strong> <br />
                <small> <i className="fa fa-envelope"></i> {userDetails.email} </small>
                <small> <i className="fa fa-phone"></i> {userDetails.mobile} </small>
              </li>
              {/* <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=dashboard")}`} to="/profile?tab=dashboard">
                  <i className="ri ri-dashboard-3-line"></i> Dashboard
                </Link>
              </li>
              <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=myProfile")}`} to="/profile?tab=myProfile">
                  <i className="ri ri-profile-line"></i> My Profile
                </Link>
              </li>
               <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=appliedJobs")}`} to="/profile?tab=appliedJobs">
                  <i className="ri ri-suitcase-line"></i> Applied Job
                </Link>
              </li>
              <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=savedJobs")}`} to="/profile?tab=savedJobs">
                  <i className="ri ri-save-line"></i> Saved Jobs
                </Link>
              </li> */}

              <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=editProfile")}`} to="/profile?tab=editProfile">
                  <i className="ri ri-edit-2-line"></i> Edit Profile
                </Link>
              </li>

              {/* <li>
                <Link className="dropdown-item" to="/profile?tab=cvDownload">
                  <i className="ri ri-download-2-line"></i> CV Download
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/profile?tab=profileVisit">
                  <i className="ri ri-user-follow-line"></i> Profile Visit
                </Link>
              </li> */}
              <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=changeSettings&open=pills-change-password")}`} to="/profile?tab=changeSettings&open=pills-change-password">
                  <i className="ri ri-fingerprint-line"></i> Change Password
                </Link>
              </li>
              <li>
                <Link className={`dropdown-item ${isActive("/profile?tab=changeSettings")}`} to="/profile?tab=changeSettings">
                  <i className="ri ri-settings-3-line"></i> Setting
                </Link>
              </li>
              <li>
                <a className="dropdown-item" href="#" onClick={logout}>
                  <i className="ri ri-logout-box-line"></i> Sign out
                </a>
              </li>
            </ul>
          </div>
        </div>
        
      );
    } else if (userType == "employer") {
      return (
          <div className="d-flex">
            <div className="main_dash_link">
              <Link className={``} to="/profile?tab=dashboard">
                Dashboard
              </Link>
            </div>
            <div className="dropdown header_notification">
                {/* <audio ref={heartbeatRef} src="/portal/images/bell.mp3" preload="auto" />
                <Link
                  className="dropdown-toggle link-notification"
                  to="/"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <i className="fa fa-bell-o"></i>
                </Link> */}

              <Link className={`dropdown-toggle link-notification`} to="/" 
                data-bs-toggle="dropdown" aria-expanded="false" id="play">
                <i className="fa fa-bell-o"></i>
              </Link>
              <div className="dropdown-menu text-small">
                  <div className="dashboard-notifications-list flex-grow-1">
                    <div className="notifications_filter">
                      <Link to="/notifications">Unread</Link>
                      <Link to="/notifications" className={`active`}>All</Link>
                      <input type="text" placeholder="Search notifications" />
                    </div>
                      <div className="dashboard-notification-item position-relative">
                          <div className="dashboard-notification-dot"></div>
                          <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                          <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                              been shortlisted.</p>
                          <span className="dashboard-notification-time">Invalid Date</span>
                      </div>
                      <div className="dashboard-notification-item position-relative read">
                          <div className="dashboard-notification-dot"></div>
                          <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                          <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                              been shortlisted.</p>
                          <span className="dashboard-notification-time">Invalid Date</span>
                      </div>
                      <div className="dashboard-notification-item position-relative read">
                          <div className="dashboard-notification-dot"></div>
                          <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                          <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                              been shortlisted.</p>
                          <span className="dashboard-notification-time">Invalid Date</span>
                      </div>
                      <div className="dashboard-notification-item position-relative read">
                          <div className="dashboard-notification-dot"></div>
                          <h5 className="dashboard-notification-title m-a0">New Message from Vianet Communications</h5>
                          <p className="dashboard-notification-desc m-t5 m-b5">Your application for Senior Frontend Developer has
                              been shortlisted.</p>
                          <span className="dashboard-notification-time">Invalid Date</span>
                      </div>
                  </div>
                  <div className="notification_footer">
                      {/* <a href="javascript:;" className="dashboard-notifications-view-all-btn btn w-100">View All</a> */}
                      <Link to="/notifications" className={`text-dark`}><b>Mark all read</b></Link>
                      <Link to="/notifications" className={`text-danger`}>Clear all</Link>
                  </div>
              </div>
            </div>
            <div className="dropdown text-end">
              <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle"
                data-bs-toggle="dropdown" aria-expanded="false" >
                <img  
                src={userDetails.photo ? `/uploads/emp_img/${userDetails.photo}` : '/default/profile_picture.png'}
                alt=""  
                className="rounded-circle" />
                {/* <strong>{userDetails.first_name || userDetails.username}</strong> */}
              </a>
              <ul className="dropdown-menu text-small shadow header_account_dropdown">
                <li>
                  <strong>{userDetails.first_name || userDetails.username}</strong> <br />
                  <small> <i className="fa fa-envelope"></i> {userDetails.email} </small>
                  <small> <i className="fa fa-phone"></i> {userDetails.mobile} </small>
                </li>
                {/* <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=dashboard")}`} to="/profile?tab=dashboard">
                    <i className="ri ri-dashboard-3-line"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=myProfile")}`} to="/profile?tab=myProfile">
                    <i className="ri ri-profile-line"></i> My Profile
                  </Link>
                </li>
                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=appliedJobs")}`} to="/profile?tab=appliedJobs">
                    <i className="ri ri-suitcase-line"></i> Applied Job
                  </Link>
                </li>
                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=savedJobs")}`} to="/profile?tab=savedJobs">
                    <i className="ri ri-save-line"></i> Saved Jobs
                  </Link>
                </li> */}

                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=editProfile")}`} to="/profile?tab=editProfile">
                    <i className="ri ri-edit-2-line"></i> Edit Profile
                  </Link>
                </li>

                {/* <li>
                  <Link className="dropdown-item" to="/profile?tab=cvDownload">
                    <i className="ri ri-download-2-line"></i> CV Download
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/profile?tab=profileVisit">
                    <i className="ri ri-user-follow-line"></i> Profile Visit
                  </Link>
                </li> */}
                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=changeSettings&open=pills-change-password")}`} to="/profile?tab=changeSettings&open=pills-change-password">
                    <i className="ri ri-fingerprint-line"></i> Change Password
                  </Link>
                </li>
                <li>
                  <Link className={`dropdown-item ${isActive("/profile?tab=changeSettings")}`} to="/profile?tab=changeSettings">
                    <i className="ri ri-settings-3-line"></i> Setting
                  </Link>
                </li>
                <li>
                  <a className="dropdown-item" href="#" onClick={logout}>
                    <i className="ri ri-logout-box-line"></i> Sign out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        // <div className="dropdown  text-end">
        //   <a
        //     href="#"
        //     className="d-flex align-items-center link-dark text-decoration-none dropdown-toggle"
        //     data-bs-toggle="dropdown"
        //     aria-expanded="false"
        //   >
        //     {/* <img
        //       src={userDetails.photo}
        //       alt={userDetails.comp_name}
        //       width="32"
        //       height="32"
        //       className="rounded-circle me-2"
        //     ></img> */}
        //     <strong>{userDetails.comp_name || userDetails.username}</strong>
        //   </a>
        //   <ul className="dropdown-menu text-small shadow">
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=dashboard")}`} to="/profile?tab=dashboard">
        //         <i className="ri ri-dashboard-3-line"></i> Dashboard
        //       </Link>
        //     </li>
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=myProfile")}`} to="/profile?tab=myProfile">
        //         <i className="ri ri-profile-line"></i> Company Profile
        //       </Link>
        //     </li>
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=editProfile")}`} to="/profile?tab=editProfile">
        //         <i className="ri ri-edit-2-line"></i> Edit Profile
        //       </Link>
        //     </li>
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=postJob")}`} to="/profile?tab=postJob">
        //         <i className="ri ri-save-line"></i> Post A Job
        //       </Link>
        //     </li>
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=manageJob")}`} to="/profile?tab=manageJob">
        //         <i className="ri ri-suitcase-line"></i> Manage Jobs
        //       </Link>
        //     </li>
        //     {/* <li>
        //       <Link className="dropdown-item" to="/profile?tab=resume">
        //         <i className="ri ri-download-2-line"></i> Resume
        //       </Link>
        //     </li> */}
        //     <li>
        //       <Link className={`dropdown-item ${isActive("/profile?tab=changePassword")}`} to="/profile?tab=changePassword">
        //         <i className="ri ri-fingerprint-line"></i> Change Password
        //       </Link>
        //     </li>
        //     <li>
        //       <a className="dropdown-item" href="#" onClick={logout}>
        //         <i className="ri ri-logout-box-line"></i> Sign out
        //       </a>
        //     </li>
        //   </ul>
        // </div>       
      );
    }
  };

  return (
    <React.Fragment>
      <button
        id="mobile-side-drawer"
        type="button"
        className={`navbar-toggler ${isMobileMenuOpen ? "" : "collapsed"}`}
        onClick={() => setIsMobileMenuOpen(true)}
      >
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar icon-bar-first"></span>
        <span className="icon-bar icon-bar-two"></span>
        <span className="icon-bar icon-bar-three"></span>
      </button>
      {navMenus()}
      {rightMenu()}
    </React.Fragment>
  );
}
